export default __webpack_public_path__ + "static/media/b31b1ac73b7955c2898480def0a7f70b1581617108482.3c8ff8fd.webp";